import { useFDBodyColor } from '@facet-wealth/design';

export default function useBoneBackgroundColor() {
  useFDBodyColor('subtle');
}
